import cssVariables from 'Lib/cssVariables';

import QueryComponent from './QueryComponent';

const { desktopBreakpoint } = cssVariables;

type Props = React.PropsWithChildren<{}>;

const Desktop = (props: Props) => (
  <QueryComponent query={`(min-width: ${desktopBreakpoint + 1}px)`}>
    {props.children}
  </QueryComponent>
);

export default Desktop;
